import React from "react";
import { Spinner } from "react-bootstrap";
import RIcon from "../reservas/components/ReservasIcons";
import { courtNameFor, formatDuration, formatLongDate, formatMoney } from "./birthdayModel";
import { StepDetalles, StepFecha, StepPaquete } from "./BirthdaySteps";
import "../reservas/reservas.css";
import "../reservas/reservas-mobile.css";
import "../beauty/beauty.css";
import "./cumpleanos.css";

const STEPS = [
  { key: "paquete", label: "Elegir paquete" },
  { key: "fecha", label: "Fecha y horario" },
  { key: "detalles", label: "Tus datos" },
];

const Stepper = ({ current }) => {
  const currentIndex = STEPS.findIndex((s) => s.key === current);
  return (
    <div className="steps" style={{ marginBottom: 24 }}>
      {STEPS.map((s, i) => {
        const done = i < currentIndex;
        return (
          <React.Fragment key={s.key}>
            {i > 0 && <div className={`step-sep${i <= currentIndex ? " done" : ""}`} />}
            <div className={`step${done ? " done" : i === currentIndex ? " on" : ""}`}>
              <span className="dot">{done ? <RIcon name="check" width={13} height={13} /> : i + 1}</span>
              {s.label}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

/**
 * Desktop layout: stepper + step content on the left and a sticky summary with the primary action on the
 * right, the same structure as ClubDetailDesktop. Renders what `useBirthdayFlow` hands it.
 */
const BirthdayFlowDesktop = ({ flow, club, courts, submitLabel, onBack }) => {
  const { step, config, selectedPackage: pkg, amounts } = flow;
  const isLast = step === "detalles";

  return (
    <div className="reservas-root bday bday-desktop">
      <div className="wrap bar-detail">
        <button type="button" className="crumb" onClick={onBack}>
          <RIcon name="chevL" width={16} height={16} /> {step === "paquete" ? "Volver al club" : "Volver"}
        </button>

        <Stepper current={step} />

        <div className="bd-grid">
          <div className="bd-section" style={{ minWidth: 0 }}>
            {step === "paquete" && (
              <StepPaquete packages={flow.packages} selectedId={pkg?._id} onSelect={flow.selectPackage} />
            )}
            {step === "fecha" && (
              <StepFecha
                dateOptions={flow.dateOptions}
                date={flow.date}
                onSelectDate={flow.selectDate}
                availability={flow.availability}
                slotStart={flow.slotStart}
                onSelectStart={flow.selectStart}
                onRetry={flow.reloadAvailability}
                slotNotice={flow.slotNotice}
                courts={courts}
                courtNameOf={courtNameFor}
                calendar
              />
            )}
            {step === "detalles" && (
              <StepDetalles
                pkg={pkg}
                mode={flow.mode}
                date={flow.date}
                slotStart={flow.slotStart}
                courtName={flow.courtName}
                amounts={amounts}
                depositPercent={config.depositPercent}
                config={config}
                enabled={flow.enabledQuestions}
                form={flow.form}
                onField={flow.setField}
                errors={flow.errors}
                policyAccepted={flow.policyAccepted}
                onPolicy={flow.setPolicyAccepted}
                depositBlocked={flow.depositBlocked}
                submitError={flow.submitError}
                hideSummary
              />
            )}
          </div>

          <div className="bd-sidebar-sticky">
            <div className="reserve-stick" aria-label="Resumen del cumpleaños">
              <div className="rs-head">
                <div className="t">Tu cumple</div>
                <div className="n">{club.name}</div>
              </div>
              <div className="rs-body">
                {!pkg ? (
                  <div className="rs-empty">
                    <RIcon name="cal" width={34} height={34} />
                    <br />
                    Elegí un paquete para armar tu cumple.
                  </div>
                ) : (
                  <>
                    <div className="rs-row">
                      <span className="k"><RIcon name="ticket" />Paquete</span>
                      <span className="v">{pkg.name}</span>
                    </div>
                    <div className="rs-row">
                      <span className="k"><RIcon name="clock" />Duración</span>
                      <span className="v">{formatDuration(pkg.durationMinutes)}</span>
                    </div>
                    {flow.date && (
                      <div className="rs-row">
                        <span className="k"><RIcon name="cal" />Fecha</span>
                        <span className="v">{formatLongDate(flow.date)}</span>
                      </div>
                    )}
                    {flow.slotStart && (
                      <div className="rs-row">
                        <span className="k"><RIcon name="clock" />Horario</span>
                        <span className="v">{flow.slotStart} hs</span>
                      </div>
                    )}
                    {flow.slotStart && flow.courtName && (
                      <div className="rs-row">
                        <span className="k"><RIcon name="court" />Cancha</span>
                        <span className="v">{flow.courtName}</span>
                      </div>
                    )}
                    <div className="rs-div" />
                    <div className="rs-total">
                      <span className="k">Total</span>
                      <span className="v">{formatMoney(amounts.total)}</span>
                    </div>
                    {config.depositPercent > 0 && (
                      <div className="rs-row">
                        <span className="k">Seña ({config.depositPercent}%)</span>
                        <span className="v">{formatMoney(amounts.deposit)}</span>
                      </div>
                    )}
                    <div className="rs-row">
                      <span className="k">Saldo a pagar en el club</span>
                      <span className="v">{formatMoney(amounts.balance)}</span>
                    </div>
                  </>
                )}
                <div className="rs-div" />
                {isLast ? (
                  <button
                    type="button"
                    className="r-btn-primary rs-cta"
                    disabled={flow.submitting || flow.depositBlocked}
                    onClick={flow.submit}
                  >
                    {flow.submitting ? <Spinner animation="border" size="sm" /> : submitLabel}
                  </button>
                ) : (
                  <button type="button" className="r-btn-primary rs-cta" disabled={!flow.canContinue} onClick={flow.goNext}>
                    Continuar <RIcon name="arrowR" width={17} height={17} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BirthdayFlowDesktop;
